import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getStandaloneReport } from "./actions";
import MapContainer from "./MapContainer";
import { StyledHeader } from "../../styles";
import {
    Card,
    CardContent,
    Button,
    Typography,
    Table,
    TableBody,
    TableRow
} from "@material-ui/core";
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { gridStyle, cellStyle } from "../gridHelper";
import "../imgDiv.css";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { cellStyle as cstyle } from "../gridHelper";

class DigReport extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        }
        else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: [],
            imageModal: false,
            selectedImg: false
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    renderSketches(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedImg: photo.photo_url,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: "100px",
                                height: "100px",
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        return attachedSigs.map((sig, i) => {
            if (sig.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + sig.signature_url
            }
            let sigInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            sigRow,
                            sigCell,
                            sigRow,
                            sigCell,
                            true
                        )}
                    >
                        {sig.signature_name}
                    </div>
                    <div
                        style={cstyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    {sig.signature_url.includes("https:")
                        ?
                        <div
                            style={cstyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={sig.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        imageModal: true,
                                        selectedImg: sig.signature_url
                                    })
                                }}
                                style={{
                                    width: 300,
                                    height: "140px",
                                    margin: "auto",
                                    cursor: "pointer"
                                }}
                            />
                        </div>
                        :

                        <div
                            style={cstyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        imageModal: true,
                                        selectedImg: ref
                                    })
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer"
                                }}
                            />
                        </div>

                    }
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }

    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedImg: photo.photo_url,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: "200px",
                                height: "200px",
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    renderSingleSigs(sig) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        // return attachedSigs.map((sig, i) => {
        if (sig.signature_url.includes("https:") === false) {
            ref = "data:image/png;base64," + sig.signature_url
        }
        let sigInfo = (
            <React.Fragment>
                <div
                    style={cstyle(
                        sigRow,
                        sigCell,
                        sigRow,
                        sigCell,
                        true
                    )}
                >
                    {sig.signature_name}
                </div>
                <div
                    style={cstyle(
                        sigRow,
                        sigCell + 1,
                        sigRow,
                        sigCell + 1,
                        true
                    )}
                >
                    {sig.signature_timestamp}
                </div>
                {sig.signature_url.includes("https:")
                    ?
                    <div
                        style={cstyle(
                            sigRow + 1,
                            sigCell,
                            sigRow + 1,
                            sigCell + 2
                        )}
                    >
                        <img
                            src={sig.signature_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    imageModal: true,
                                    selectedImg: sig.signature_url
                                })
                            }}
                            style={{
                                width: 300,
                                height: "125px",
                                margin: "auto",
                                cursor: "pointer"
                            }}
                        />
                    </div>
                    :

                    <div
                        style={cstyle(
                            sigRow + 1,
                            sigCell,
                            sigRow + 1,
                            sigCell + 2
                        )}
                    >
                        <img
                            src={ref}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    imageModal: true,
                                    selectedImg: ref
                                })
                            }}
                            style={{
                                width: 300,
                                height: "125px",
                                margin: "auto",
                                cursor: "pointer"
                            }}
                        />
                    </div>

                }
            </React.Fragment>
        );
        sigCell += 2;
        if (sigCell === 9) {
            sigRow += 2;
            sigCell = 1;
        }
        return sigInfo;
        // });
    }

    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = cellStyle;
        const gstyle = gridStyle;
        let color = this.props.color;
        return (
            <Card>
                <StyledHeader>
                    <Typography variant="h5">Scan Log / Permit To Dig Report</Typography>
                </StyledHeader>
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px"
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (

                        <div ref={el => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <div style={{ width: "100%" }}>
                                <div style={{ width: "60%", float: "left" }}>
                                    <div style={gstyle(7, 13, null, color)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Report Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            Name:&nbsp;<b>{report.user_name
                                                ? report.user_name
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            Email:&nbsp;<b>{report.user_email
                                                ? report.user_email
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            Job Name:&nbsp;<b>{report.job_name
                                                ? report.job_name
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13, true)}>
                                            Location:&nbsp;<b>{report.location
                                                ? report.location
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            Site: &nbsp; <b>{report.site
                                                ? report.site
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13, true)}>
                                            Permit Id:&nbsp;<b>{report.permit_id
                                                ? report.permit_id
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            Longitude:&nbsp;<b>{report.location_lon
                                                ? report.location_lon
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13, true)}>
                                            Latitude:&nbsp;<b>{report.location_lat
                                                ? report.location_lat
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(6, 1, 6, 13)}>
                                            Timestamp:&nbsp;<b>{report.timestamp
                                                ? report.timestamp
                                                : "N/A"}</b>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "30%",
                                        float: "left",
                                        marginLeft: "2%"
                                    }}
                                >
                                    <MapContainer
                                        lat={+report.location_lat}
                                        long={+report.location_lon}
                                        style={{ width: "80%" }}
                                    />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <br />
                            <div style={{ clear: "both", width: "1000px" }}>
                                <ExpansionPanel defaultExpanded={true}>
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{ backgroundColor: "#0188cc", borderRadius: "6px", fontSize: "22px" }}
                                    >
                                        <h3 style={{
                                            textAlign: "center",
                                            padding: "4px",
                                            fontWeight: "bold",
                                            color: "white",
                                            borderRadius: "6px",
                                            fontSize: "22px"

                                        }}>
                                            Dig Details
                                </h3>
                                    </ExpansionPanelSummary>
                                    <div>
                                        <Table>
                                            <TableBody>
                                                {report.dig_items && report.dig_items.map((e, i) => {
                                                    return (
                                                        <TableRow key={i}>
                                                            <div className="icon-text-container" style={{ borderWidth: "medium", border: "7px solid #0188cc", borderRadius: "9px", marginTop: "10px" }} >
                                                                {/* <p style={{ textAlign: "center", backgroundColor: "#c7c7cc", marginTop: "5px", paddingTop: "4px", paddingBottom: "4px", fontWeight: "bold" }}>Dig Timestamp:&nbsp;{e.dig_timestamp}</p> */}
                                                                <div >
                                                                    <div>
                                                                        <p style={{ textAlign: "center", backgroundColor: "#c7c7cc", marginTop: "5px", paddingTop: "4px", paddingBottom: "4px", fontWeight: "bold" }}>Utility Drawings Available</p>
                                                                        <div
                                                                            className="icon-text-container"
                                                                            style={{
                                                                                borderWidth: "medium",
                                                                                marginTop: "10px",
                                                                                marginLeft: "10px",
                                                                                marginRight: "10px",
                                                                                marginBottom: "10px",
                                                                                display: "flex"
                                                                            }}
                                                                        >
                                                                            <p style={{ marginLeft: "20px" }}>
                                                                                <b>Water:&nbsp;</b>{e.utility_drawing_water}
                                                                            </p>
                                                                            <p style={{ marginLeft: "25px" }}>
                                                                                <b>Gas:&nbsp;</b> {e.utility_drawing_gas}
                                                                            </p>

                                                                            <p style={{ marginLeft: "25px" }}>
                                                                                <b>Telecom:&nbsp;</b> {e.utility_drawing_telecom}
                                                                            </p>
                                                                            <p style={{ marginLeft: "25px" }}>
                                                                                <b>Utility Services (ESB, NIE, SSE etc):&nbsp;</b> {e.utility_drawing_services}
                                                                            </p>
                                                                            <div className="clear"></div>
                                                                        </div>
                                                                        {e.utility_drawing_water === "No" && e.utility_drawing_gas === "No" && e.utility_drawing_telecom === "No" && e.utility_drawing_services === "No"
                                                                            ? ""
                                                                            :
                                                                            <p style={{ marginLeft: "32px" }}>
                                                                                <b>Utility Drawings Used:&nbsp;</b> {e.utility_drawing_used}
                                                                            </p>
                                                                        }
                                                                        {typeof e.attached_sketches === "undefined" || e.attached_sketches === "null" ? ""
                                                                        :
                                                                        <div style={{marginLeft:"10px", marginRight:"10px"}}>
                                                                            <div style={gstyle(4, 9, null, color)}>
                                                                                <div style={cstyle(1, 1, 1, 1, false, true)}>
                                                                                    <b>Attached Sketches</b>
                                                                                </div>
                                                                                {e.attached_sketches &&
                                                                                    this.renderSketches(e.attached_sketches)}
                                                                            </div>
                                                                        </div>
                                                                         }
                                                                        <div
                                                                            className="icon-text-container"
                                                                            style={{
                                                                                borderWidth: "medium",
                                                                                marginTop: "10px",
                                                                                marginLeft: "10px",
                                                                                marginRight: "10px",
                                                                                marginBottom: "10px",
                                                                                display: "flex"
                                                                            }}
                                                                        >
                                                                            <p style={{ marginLeft: "20px" }}>
                                                                                <b>Location:&nbsp;</b>{e.dig_location ? e.dig_location : "N/A"}
                                                                            </p>
                                                                            <p style={{ marginLeft: "60px" }}>
                                                                                <b>Timestamp:&nbsp;</b> {e.dig_timestamp}
                                                                            </p>   
                                                                        </div>
                                                                        <p style={{ textAlign: "center", backgroundColor: "#b9d6da", marginTop: "5px", paddingTop: "4px", paddingBottom: "4px", fontWeight: "bold" }}>Equipment Details</p>
                                                                        <div
                                                                            className="icon-text-container"
                                                                            style={{
                                                                                borderWidth: "medium",
                                                                                marginTop: "10px",
                                                                                marginLeft: "10px",
                                                                                marginRight: "10px",
                                                                                marginBottom: "10px",
                                                                                display: "flex"
                                                                            }}
                                                                        >
                                                                            <p style={{ marginLeft: "20px" }}>
                                                                                <b>Scan Equipment Used:&nbsp;</b>{e.scan_equipment ? e.scan_equipment : "N/A"}
                                                                            </p>
                                                                            <p style={{ marginLeft: "40px" }}>
                                                                                <b>Equipment Calibration Date:&nbsp;</b> {e.scan_equipment_calibration_date ? e.scan_equipment_calibration_date : "N/A"}
                                                                            </p>   
                                                                            <p style={{ marginLeft: "40px" }}>
                                                                                <b>Depth of the Service (mm):&nbsp;</b> {e.depth_of_the_service ? e.depth_of_the_service : "N/A"}
                                                                            </p>  
                                                                        </div>

                                                                        <div
                                                                            className="icon-text-container"
                                                                            style={{
                                                                                borderWidth: "medium",
                                                                                marginTop: "10px",
                                                                                marginLeft: "10px",
                                                                                marginRight: "10px",
                                                                                marginBottom: "10px",
                                                                                display: "flex"
                                                                            }}
                                                                        >
                                                                            <p style={{ marginLeft: "20px" }}>
                                                                                <b>ROL Number and Utility Map Reference No:&nbsp;</b>{e.rol_number_and_utility_map_ref ? e.rol_number_and_utility_map_ref : "N/A"}
                                                                            </p>
                                                                             
                                                                        </div>

                                                                        <p style={{ textAlign: "center", backgroundColor: "#c7c7cc", marginTop: "5px", paddingTop: "4px", paddingBottom: "4px", fontWeight: "bold" }}>Scanning Modes Used</p>
                                                                        <div
                                                                            className="icon-text-container"
                                                                            style={{
                                                                                borderWidth: "medium",
                                                                                marginTop: "10px",
                                                                                marginLeft: "10px",
                                                                                marginRight: "10px",
                                                                                marginBottom: "10px",
                                                                                display: "flex"
                                                                            }}
                                                                        >
                                                                            <p style={{ marginLeft: "20px" }}>
                                                                                <b>Power:&nbsp;</b>{e.scan_mode_power}
                                                                            </p>
                                                                            <p style={{ marginLeft: "40px" }}>
                                                                                <b>Radio:&nbsp;</b> {e.scan_mode_radio}
                                                                            </p>

                                                                            <p style={{ marginLeft: "40px" }}>
                                                                                <b>Genny:&nbsp;</b> {e.scan_mode_genny}
                                                                            </p>
                                                                            <p style={{ marginLeft: "40px" }}>
                                                                                <b>Direct Connect:&nbsp;</b> {e.scan_mode_direct_connect}
                                                                            </p>
                                                                            <p style={{ marginLeft: "40px" }}>
                                                                                <b>Induction:&nbsp;</b> {e.scan_mode_induction}
                                                                            </p>
                                                                            <div className="clear"></div>
                                                                        </div>

                                                                        <div
                                                                            className="icon-text-container"
                                                                            style={{
                                                                                borderWidth: "medium",
                                                                                marginTop: "10px",
                                                                                marginLeft: "10px",
                                                                                marginRight: "10px",
                                                                                marginBottom: "10px",
                                                                                display: "flex"
                                                                            }}
                                                                        >
                                                                            <p style={{ marginLeft: "20px" }}>
                                                                                <b>ROL Number and Utility Map Reference No:&nbsp;</b>{e.rol_number_and_utility_map_ref ? e.rol_number_and_utility_map_ref : "N/A"}
                                                                            </p>
                                                                             
                                                                        </div>
                                                                        <div
                                                                            className="icon-text-container"
                                                                            style={{
                                                                                borderWidth: "medium",
                                                                                marginTop: "10px",
                                                                                marginLeft: "10px",
                                                                                marginRight: "10px",
                                                                                marginBottom: "10px",
                                                                                display: "flex"
                                                                            }}
                                                                        >
                                                                            <p style={{ marginLeft: "20px" }}>
                                                                                <b>Agreed Digging Method:&nbsp;</b>{e.agreed_digging_method ? e.agreed_digging_method : "N/A"}
                                                                            </p> 
                                                                        </div>

                                                                        {typeof e.attached_photos === "undefined" || e.attached_photos === "null" ? ""
                                                                        :
                                                                            <div style={{marginLeft:"10px", marginRight:"10px"}}>
                                                                                <div style={gstyle(4, 9, null, color)}>
                                                                                    <div style={cstyle(1, 1, 1, 1, false, true)}>
                                                                                        <b>Attached Sketches</b>
                                                                                    </div>
                                                                                    {e.attached_photos &&
                                                                                        this.renderPhotos(e.attached_photos)}
                                                                                </div>
                                                                            </div>
                                                                        }


                                                                    </div>

                                                                </div>
                                                                <div className="clear"></div>
                                                            </div>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </ExpansionPanel>
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Signatures</b>
                                    </div>
                                    {report.attached_signature &&
                                        this.renderSingleSigs(
                                            report.attached_signature
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Image Details</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={

                                        this.state.selectedImg
                                            ? this.state.selectedImg
                                            : noImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: "",
                                            imageModal: false
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            report: selectCurrentReport(store)
        };
    },
    { getReport, getStandaloneReport }
)(DigReport);
